import { FC } from 'react'
import { QRCodeCanvas } from 'qrcode.react'

import { useQrCodeStore } from 'shared/store/qrCodeSlice'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'
import { getAppName } from 'shared/helpers/getAppName'

import {
  QRCodeContainer,
  OrderPaySpecial,
  FrameDiv,
  ScannerText,
  LogoSpecial,
  TableNameSpecial,
  LogoSpecialContainer
} from './styled'
import { RenderIf } from 'shared/helpers/renderIf'

export const SpecialLayout: FC = () => {
  const isCC = useGlobalStore().isCCSelected
  const { qrCodeValue, selectedCaption } = useQrCodeStore()
  const interfaceConfig = useConfigStore().config?.interfaceConfig

  return (
    <FrameDiv color={interfaceConfig?.[getAppName(isCC)]?.colour}>
      <TableNameSpecial>
        <RenderIf condition={!!selectedCaption?.length}>
          <p>{selectedCaption}</p> <p>Tisch №</p>
        </RenderIf>
      </TableNameSpecial>
      <LogoSpecialContainer>
        <LogoSpecial src={interfaceConfig?.[getAppName(isCC)]?.logoImage} alt='logo' />
      </LogoSpecialContainer>
      <QRCodeContainer>
        <QRCodeCanvas value={qrCodeValue} size={105} />
      </QRCodeContainer>
      <ScannerText>
        Scannen Sie den Code mit Ihrer Smartphone Kamera oder geben Sie im Browser
        deintisch.app/scanner ein
      </ScannerText>
      <OrderPaySpecial>Bestellen & Bezahlen</OrderPaySpecial>
      <ScannerText>Wir servieren Ihre Bestellung an Ihren Tisch</ScannerText>
    </FrameDiv>
  )
}
